import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "登录",
    component: () => import("/src/views/login/login.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/medicalRecord",
    name: "病历查看",
    component: () => import("/src/views/medicalRecord/medicalRecord.vue"),
    meta: { requiresAuth: false }
  },
  {
    path: "/",
    name: "首页",
    redirect: "/disease",
    meta: { requiresAuth: true }
  },
  {
    path: "/disease",
    name: "疾病名管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/disease/search.vue"),
  },
  {
    path: "/syndrome",
    name: "症候群名管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/syndrome/search.vue"),
  },
  {
    path: "/prescription",
    name: "处方管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/prescription/search.vue"),
  },
  {
    path: "/medicine",
    name: "药名管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/medicine/search.vue"),
  },
  {
    path: "/role",
    name: "角色管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/role/search.vue"),
  },
  {
    path: "/permission",
    name: "权限管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/permission/search.vue"),
  },
  {
    path: "/menu",
    name: "菜单管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/menu/search.vue"),
  },
  {
    path: "/group",
    name: "用户组管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/group/search.vue"),
  },
  {
    path: "/module",
    name: "模块管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/module/search.vue"),
  },
  {
    path: "/club",
    name: "门店菜单管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/club/search.vue"),
  },
  {
    path: "/consultation",
    name: "就诊一览",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/consultation/search.vue"),
  },
  {
    path: "/product",
    name: "药品管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/product/search.vue"),
  },
  {
    path: "/task",
    name: "批量任务管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/task/search.vue"),
  },
  {
    path: "/member",
    name: "员工管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/member/search.vue"),
  },
  {
    path: "/monthlyReports",
    name: "汇总报表",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/monthlyReports/search.vue"),
  },
  {
    path: "/listReports",
    name: "清单报表",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/listReports/search.vue"),
  },
  {
    path: "/performanceVerification",
    name: "业绩核对",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/performanceVerification/search.vue"),
  },
  {
    path: "/innerStudy",
    name: "自学习结果统计",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/innerStudy/search.vue"),
  },
  {
    path: "/usageHabit",
    name: "使用习惯统计",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/usageHabit/search.vue"),
  },
  {
    path: "/todayConsultation",
    name: "今日看诊",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/todayConsultation/search.vue"),
  },
  {
    path: "/intelligentQuery",
    name: "智能查询",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/intelligentQuery/search.vue"),
  },
  {
    path: "/doctorManage",
    name: "出诊管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/doctorManage/search.vue"),
  },
  {
    path: "/doctorSchedule",
    name: "排班管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/doctorSchedule/search.vue"),
  },
  {
    path: "/businessOverview",
    name: "业务总览",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/businessManage/overview/detail.vue"),
  },
  {
    path: "/businessAppointment",
    name: "单日预约管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/businessManage/appointment/search.vue"),
  },
  {
    path: "/dailyAppointmentSummary",
    name: "预约汇总",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/appointment/DailySummary.vue"),
  },
  {
    path: "/businessSummary",
    name: "预约一览",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/businessManage/summary/search.vue"),
  },
  {
    path: "/linkEnterprise",
    name: "关联企业",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/linkEnterprise/search.vue"),
  },
  {
    path: "/microTest",
    name: "小医微测管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/microTest/search.vue"),
  },
  {
    path: "/newCustomerSource",
    name: "新客信息管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/newCustomerSource/search.vue"),
  },
  {
    path: "/shopType",
    name: "类型管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/type.vue"),
  },
  {
    path: "/PromoType",
    name: "促销品类管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/PromoType.vue"),
  },
  {
    path: "/mallProduct",
    name: "商品管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/ProductList.vue"),
  },
  {
    path: "/activity",
    name: "最新活动",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/activity.vue"),
  },
  {
    path: "/mallSetting",
    name: "商城配置管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/mallSetting.vue"),
  },
  {
    path: "/productDisplay",
    name: "商品展示信息",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/productDisplay.vue"),
  },
  {
    path: "/promotion",
    name: "优惠管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/shopping/promotion.vue"),
  },
  {
    path: "/wechatOAPromotion",
    name: "公众号推广管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/wechatOAPromotion/search.vue"),
  },
  {
    path: "/couponAssociation",
    name: "优惠券关联",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/couponAssociation/search.vue"),
  },
  {
    path: "/test",
    name: "测试",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/test/search.vue"),
  },
  {
    path: "/order",
    name: "订单管理",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/order/search.vue"),
  },
  {
    path: "/customer",
    name: "患者筛选",
    meta: {
      keepAlive: true,
      limite: "可编辑",
      requiresAuth: true
    },
    component: () => import("/src/views/customer/search.vue"),
  },
  // 404页面
  {
    path: "/:pathMatch(.*)*",
    redirect: "/disease"
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 白名单路由（无需登录即可访问）
const whiteList = ['/login', '/medicalRecord'];

// 路由守卫
router.beforeEach((to, from, next) => {
  const hasToken = !!localStorage.getItem('token');
  const isWhiteList = whiteList.includes(to.path);
  
  if (hasToken && to.path === '/login') {
    // 已登录用户访问登录页 → 跳首页
    next({ path: '/' });
  } else if (!hasToken && !isWhiteList) {
    // 未登录且访问非白名单页面 → 跳登录页（携带目标地址）
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    // 其他情况正常放行
    next();
  }
});

export default router;